import { Button, LinearProgress } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import { SendRounded } from "@mui/icons-material";
import LoopRoundedIcon from '@mui/icons-material/LoopRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

import { useStepForms } from "../../hooks/useStepForms";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MAX_STEPS } from "../../../../config/constants/maxSteps";
import getPercentageProgress from "../../../../ui/utils/getPercentageProgress";

// eslint-disable-next-line react/prop-types
export const DraftForms = ({parentRef}) => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  
  //('[FORM CONTAINER] Se reenderizo');

  const { 
      currentForm:{title, caption, CustomForm},
      currentProgress,
      hideBackButton,
      isLastForm,
      isReviewForm,
      canReturnHome,
      formSubmissionStatus,
      handleSubmitForm, 
      handleBackForm 
  } = useStepForms(parentRef);

  return (
    <section className="draft__form">
      <div className="draft__form--info">
          <h1 className="black-text xxl-text">{title}</h1>
          <p className="grey-text md-text">{caption}</p>
          <div className="separator"/>
      </div>

      <form onSubmit={ (event)=> handleSubmitForm(isLastForm, setIsLoading, event)}>
          <div className="draft__form--form">
              <CustomForm 
                parentRef = {parentRef} 
                formSubmissionStatus = {formSubmissionStatus}/>
          </div>
          <div className="draft__form--bottom">
            <div className="draft__form--progress">
              <p className="md-text grey-text">
                {
                  isReviewForm
                  ? canReturnHome ? 'Documento enviado' : 'Cargando...'
                  : `Paso ${currentProgress} de ${MAX_STEPS}`
                }
              </p>
              

              <LinearProgress 
                variant="determinate" 
                color="primary"
                className="draft__form--progress--bar"
                sx={{
                  margin: '10px 0',
                  border: '0px solid transparent',
                  borderRadius: '50px',
                  backgroundColor: 'var(--border-color)',
                  height: '3px'
                }}
                value = {
                  currentProgress <= MAX_STEPS 
                  ? getPercentageProgress(currentProgress, MAX_STEPS)
                  : 100
                }
                  
                  />
            </div>
            <div 
              className="draft__form--buttons"
              style={ hideBackButton ? {display:'block', textAlign: 'end'}: {}}>
              {
                !hideBackButton 
                && <Button
                      disableElevation
                      color="secondary"
                      variant="text"
                      onClick={handleBackForm}
                    >Atrás</Button>
              }
              
              {
                isLastForm
                ? <LoadingButton
                    className="submit-button"
                    variant="contained"
                    style={{fontWeight: 'bold'}}
                    loading={isLoading}
                    disableElevation
                    
                    type={!canReturnHome && "submit"}
                    endIcon={formSubmissionStatus.response.hasError 
                      ? <LoopRoundedIcon /> 
                      : canReturnHome 
                        ? <ArrowForwardRoundedIcon/>
                        : <SendRounded/>
                      }
                    onClick={() => {
                        console.log('Can return home? ', canReturnHome);
                        canReturnHome && navigate('/');
                    } }
                    >
                      {
                        isLoading
                          ? null
                          : formSubmissionStatus.response.hasError 
                            ? 'Reintentar'
                            : canReturnHome
                              ? 'Inicio'
                              : 'Enviar'
                      }
                  </LoadingButton>
                : <Button
                    type="submit"
                    className="submit-button"
                    disableElevation
                    variant="contained"
                    endIcon={<ArrowForwardRoundedIcon sx={{fontSize: '12px'}}/>}
                    >
                      Siguiente
                  </Button>
              }
            </div>
          </div>
      </form>
    </section>
  );
};
/*
<progress id="progress-document" max={MAX_STEPS} value={currentProgress}/>
*/